<script setup>
import { computed } from 'vue';
import PgeButton from '../../../../pge-components/pge-button.vue';

const props = defineProps({
    currentFormStepData: {
        type: Object,
        default: () => ({}),
    },
});

const used = computed(() => props.currentFormStepData.state === 'used');

function goToSignIn() {
    window.location.assign('/login?email=' + encodeURIComponent(props.currentFormStepData.email));
}
</script>

<template>
    <div class="form">
        <h1 class="form__title">{{ used ? 'You have already used this link' : 'This link has expired' }}</h1>
        <div class="form__content">
            {{ used ? 'Your account already exists — sign in to carry on.' : 'This invitation link is no longer valid.' }}
        </div>
        <pge-button label="Go to sign in" @click="goToSignIn" />
    </div>
</template>

<style lang="scss" scoped>
.form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;

    &__title {
        margin: 0;
        color: #000;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Lato, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
    }

    &__content {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #000;
    }
}
</style>
